import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnDescription,
  columnMultiSelect,
  columnName,
  columnSize,
  columnTransferable,
  columnType,
  hasColumn,
} from '@/constants/fields';
import SelectableRow from '@/components/table/SelectableRow';
import { formatBytes } from '@/utils/fileHelper';
import { attachmentIcon } from '@/datasets/attachments/helper';
import { ATTACHMENT_TRANSFER } from '@/datasets/attachments/constants';
import MultiSelectCell from '@/components/table/MultiSelectCell';
import AttachmentTypeFlag from '@/datasets/attachments/components/AttachmentTypeFlag';
import NameCell from '@/components/table/NameCell';
import SimpleCell from '@/components/table/SimpleCell';
import MarkdownPopup from '@/components/MarkdownPopup';
import RequestAttachmentTransferCell from './RequestAttachmentTransferCell';
import { allowAttachmentSelection } from '../state/state';

const RequestAttachmentRow = ({
  columns,
  isRoot,
  item,
  onCheckBoxClick,
  onFolderClick,
  theme,
}) => {
  const { iconName, iconTitle } = attachmentIcon(item);
  const { transferable } = item.metadata;
  const isRequired = transferable === ATTACHMENT_TRANSFER.required.name;
  const isRecommended = transferable === ATTACHMENT_TRANSFER.recommended.name;

  return (
    <SelectableRow
      columns={isRequired ? [] : columns}
      onClick={onCheckBoxClick ? () => onCheckBoxClick(item.id) : undefined}
      positive={isRequired}
      selectable={isRoot ? allowAttachmentSelection(item) : false}
      selected={isRequired ? false : item.selected}
      warning={isRecommended}
    >
      {isRequired && hasColumn(columns, columnMultiSelect) && <MultiSelectCell checked disabled />}
      {hasColumn(columns, columnName) && !onFolderClick && (
        <NameCell name={item.name} icon={iconName} message={iconTitle} />
      )}
      {hasColumn(columns, columnName) && onFolderClick && (
        <NameCell
          name={item.name}
          icon={iconName}
          message={iconTitle}
          className="pointer"
          href
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();

            onFolderClick({ folder: { name: item.name, id: item.id } });
          }}
        />
      )}
      {hasColumn(columns, columnDescription) && item.metadata.description && (
        <Table.Cell className="aridhia-markdown-cell-popup td-description">
          <MarkdownPopup content={item.metadata.description} className="td-description" theme={theme} />
        </Table.Cell>
      )}
      {hasColumn(columns, columnDescription) && !item.metadata.description && <SimpleCell />}
      {hasColumn(columns, columnType) && (
        <Table.Cell>
          <AttachmentTypeFlag attachment={item} />
        </Table.Cell>
      )}
      {hasColumn(columns, columnSize) && <SimpleCell content={formatBytes(item.size, false)} />}
      {hasColumn(columns, columnTransferable) && (
        <RequestAttachmentTransferCell hide={!isRequired && !isRecommended} transferable={transferable} />
      )}
    </SelectableRow>
  );
};

export default RequestAttachmentRow;
